(function() {
  const LOCAL_STORAGE_KEY = 'mybearbrick.wishlist';
  
  function updateHeader() {
    if (window.myBearBrickHeader && typeof window.myBearBrickHeader.updateCounter === 'function') {
      window.myBearBrickHeader.updateCounter();
    }
  }
  
  function dispatchUpdateEvent(items) {
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: items } }));
  }

  function getWishlist() {
    const data = localStorage.getItem(LOCAL_STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  }

  function saveWishlist(items) {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(items));
    updateHeader();
    dispatchUpdateEvent(items);
  }

  function add(productHandle) {
    let items = getWishlist();
    if (!items.includes(productHandle)) {
      items.push(productHandle);
      saveWishlist(items);
    }
  }

  function remove(productHandle) {
    let items = getWishlist();
    items = items.filter(item => item !== productHandle);
    saveWishlist(items);
  }

  function contains(productHandle) {
    return getWishlist().includes(productHandle);
  }

  function getCount() {
    return getWishlist().length;
  }

  window.myBearBrickWishlist = {
    add: add,
    remove: remove,
    contains: contains,
    getCount: getCount,
    getWishlist: getWishlist
  };

  function initialize() {
    updateHeader();
    dispatchUpdateEvent(getWishlist());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

})();